import { AutomatedTextState } from './partials/automatedTextTemplate'
import { DocketwiseSettingsState } from './partials/docketwise'
import { EngagementLetterState } from './partials/engagementLetter'
import { GenericModelSettingsState } from './partials/genericModel'
import { InvoicedSettingsState } from './partials/invoiced'
import { LegalCasePartySliderSettingsState } from './partials/legalCasePartySlider'
import { LegalCasesSettingsState } from './partials/legalCases'
import { MiscSettingsState } from './partials/misc'
import { MultifactorAuthenticationSettingsState } from './partials/multifactorAuthentication'
import { OtherDocketEntriesSettingsState } from './partials/otherDocketEntries'
import { RecordsSettingsState } from './partials/records'
import { SettingsSharedState } from './partials/shared'
import { TimezoneSettingsState } from './partials/timezone'
import { TmetricSettingsState } from './partials/tmetric'
import { TwilioSettingsState } from './partials/twilio'
import { UserAccessSettingsState } from './partials/usersAccess'
import { UserSettingsState } from './partials/user'
import { WorkflowSettingsState } from './partials/workflows'

export const SettingsState = _ => ({
  ...AutomatedTextState,
  ...DocketwiseSettingsState,
  ...EngagementLetterState,
  ...GenericModelSettingsState,
  ...InvoicedSettingsState,
  ...LegalCasePartySliderSettingsState,
  ...LegalCasesSettingsState,
  ...MiscSettingsState,
  ...MultifactorAuthenticationSettingsState,
  ...OtherDocketEntriesSettingsState,
  ...RecordsSettingsState,
  ...SettingsSharedState,
  ...TimezoneSettingsState,
  ...TmetricSettingsState,
  ...TwilioSettingsState,
  ...UserAccessSettingsState,
  ...UserSettingsState,
  ...WorkflowSettingsState,
})
